import template from './employee-card-list.html';
import controller from './employee-card-list.controller';

let employeeCardListComponent = {
  restrict: 'E',
  bindings: {
    employees: '<',
  },
  template,
  controller
};

export default employeeCardListComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/components/employee-card-list/employee-card-list.component.js